// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__c3eqn","label":"Section_label__3AqlW","contentWrap":"Section_contentWrap__yagfP","footer":"Section_footer__3mHjn","footerInner":"Section_footerInner__3QMHz"};